import { FormattedMessage } from 'react-intl';
import React from 'react';
import bemify from 'bemify-js';

//import Link from 'app/common/components/Link';

import BashCodeBlock from '../components/BashCodeBlock';
import Code from '../components/Code';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';
import SyntaxHighlighter from '../components/SyntaxHighlighter';

const bem = bemify('testing');

const codeBlock = `# CLIENT_ID=1234
# CLIENT_SECRET=asdf`;

//const repoCodeBlock = `const REPO = 'username/reponame' // CHANGE THIS`;

const codeBlock2 = `Validating project locally
No structural errors found during validation routine.
This project is structurally sound!

✔ Running integration checks ... 22 checks passed
Adding /Users/marinahand/.zapierrc to environment as ZAPIER_DEPLOY_KEY...
Running test suite with the following command:

  npm run --silent test --

 PASS  test/authentication.test.js
  oauth2 app
    ✓ generates an authorize URL (30 ms)

Test Suites: 1 passed, 1 total
Tests:       1 passed, 1 total
Snapshots:   0 total
Time:        2.56 s
Ran all test suites.
`;

const Testing = () => (
  <div className={bem()}>
    <StepTitle>
      <FormattedMessage
        defaultMessage="Testing Your App"
        id="headings-testing-your-app"
      />
    </StepTitle>
    <Paragraph>
      <FormattedMessage
        defaultMessage="The CLI includes automated testing using the Jest testing framework. This is a super useful tool and it's a highly encouraged development practice to have as much test coverage as possible for your app."
        id="descriptions-jest-testing-framework-overview"
      />
    </Paragraph>
    <Paragraph>
      <FormattedMessage
        defaultMessage="To test the GitHub example app we'll need to set up some local environment variables so that the tests can connect to your account and test repo."
        id="descriptions-github-example-app-env-setup"
      />
    </Paragraph>
    <Paragraph>
      <FormattedMessage
        defaultMessage="Open the"
        id="descriptions-open-env-file-prefix"
      />{' '}
      <Code>
        <FormattedMessage defaultMessage=".env" id="labels-env-file" />
      </Code>{' '}
      <FormattedMessage
        defaultMessage="file. You'll see some variables with some placeholders."
        id="descriptions-open-env-file-suffix"
      />
    </Paragraph>
    <SyntaxHighlighter language="bash">{codeBlock}</SyntaxHighlighter>
    <Paragraph>
      <FormattedMessage
        defaultMessage="Replace those with your GitHub Client ID and Client Secret, removing the # and save the file."
        id="descriptions-replace-github-client-credentials"
      />
    </Paragraph>
    <Paragraph>
      <FormattedMessage
        defaultMessage="Now, go ahead and run"
        id="descriptions-run-zapier-test-prefix"
      />{' '}
      <Code>
        <FormattedMessage
          defaultMessage="zapier test"
          id="labels-command-zapier-test"
        />
      </Code>
      .
    </Paragraph>
    <BashCodeBlock
      lines={[
        {
          content: 'zapier test',
          isCommand: true,
        },
      ]}
    />
    <Paragraph>
      <FormattedMessage
        defaultMessage="If everything worked you'll see a message like:"
        id="descriptions-success-output-introduction"
      />
    </Paragraph>
    <SyntaxHighlighter language="text">{codeBlock2}</SyntaxHighlighter>
    <Paragraph>
      <FormattedMessage
        defaultMessage="Note that this tutorial includes limited tests to illustrate the capabilities. You’ll want to write more comprehensive tests for your integration."
        id="descriptions-limited-tests-note"
      />
    </Paragraph>
    <Paragraph>
      <FormattedMessage
        defaultMessage="If you get errors, try"
        id="descriptions-debug-command-prefix"
      />{' '}
      <Code>
        <FormattedMessage
          defaultMessage="zapier test --debug"
          id="labels-command-zapier-test-debug"
        />
      </Code>{' '}
      <FormattedMessage
        defaultMessage="to get more information. Check your"
        id="descriptions-debug-command-and-env-check-middle"
      />{' '}
      <Code>
        <FormattedMessage defaultMessage=".env" id="labels-env-file-debug" />
      </Code>{' '}
      <FormattedMessage
        defaultMessage="file to confirm everything looks right there."
        id="descriptions-debug-command-and-env-check-suffix"
      />
    </Paragraph>
  </div>
);

export default Testing;
